// extracted by css-extract-rspack-plugin
export default {"section":"k7FF9"};